import React, { useState, useEffect, useRef } from 'react';
import { ThemeProvider, List, Button as React95Button, Modal } from '@react95/core';
import styled from 'styled-components';
import GlobalStyles from './GlobalStyles';
import PhotoAlbum from './components/PhotoAlbum';

const BootScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'OMORI_GAME', monospace;
  font-size: 24px;
  z-index: 999;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 2s ease-out;
  pointer-events: ${({ isVisible }) => (isVisible ? 'all' : 'none')};
`;

const ContentContainer = styled.div`
  background-color: black;
  opacity: ${({ opacity }) => opacity};
  transition: opacity 2s ease-in;
  width: 100vw;s
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  visibility: ${({ opacity }) => (opacity > 0 ? 'visible' : 'hidden')};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Desktop = styled.div`
  background-color: black;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const WindowBorder = styled.div`
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #606060;
  height: 90vh;
  width: 80vw;
`;

const WindowedEnvironment = styled.div`
  position: relative;
  background: linear-gradient(0deg, rgba(33,5,77,1) 0%, rgba(42,8,129,1) 30%, rgba(108,14,255,1) 100%);
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

const SlidingBackgroundStars = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: slide 48s linear infinite;
  background-image: url("/images/stars.png");
  background-size: 150%;
  background-repeat: repeat;
  image-rendering: pixelated;
  opacity: 0.4;
  overflow: hidden;
  z-index: 0;

  @keyframes slide {
    0% {
      background-position-x: 0%;
    }
    100% {
      background-position-x: 300%;
    }
  }
`;

const SlidingBackgroundObjects = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-image: url("/images/objects.png");
  background-size: 150%;
  background-repeat: repeat;
  image-rendering: pixelated;
  opacity: 0.6;
  z-index: 1;
  animation: slide 24s linear infinite;
  pointer-events: none;

  @keyframes slide {
    0% {
      background-position-x: 0%;
    }
    100% {
      background-position-x: 300%;
    }
  }
`;

const Taskbar = styled.div`
  background: #c0c0c0;
  height: 40px;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  box-shadow: inset 1px 1px #fff, inset -1px -1px #888;
`;

const StyledReact95Button = styled(React95Button)`
  && {
    margin-right: 8px;
    font-family: 'OMORI_GAME', monospace;
    font-size: 16px;
    height: 30px;
    background-color: #C0C0C0;
    border-color: #C0C0C0;
    box-shadow: 1px 1px #888, -1px -1px #fff;

    ${({ isActive }) =>
      isActive &&
      `
        background-color: #A3A3A3;
        border-color: #A3A3A3;
        box-shadow: inset 2px 2px #888, inset -2px -2px #fff;
      `}

    &:focus {
      outline: none;
    }
  }
`;

const Clock = styled.div`
  margin-left: auto;
  font-family: 'OMORI_GAME', monospace;
  font-size: 16px;
  color: black;
  text-align: center;
  padding: 2px 5px;
  background: #c0c0c0;
  box-shadow: inset 1px 1px #888, inset -1px -1px #fff;
  user-select: none;
`;

const DraggableModal = styled(Modal)`
  position: absolute;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  cursor: move;
`;

const AboutMeContent = () => (
  <div>
    <h1>welcome to my portfolio,</h1>
    <h2>i'm ethan, and i've had an <a href="https://www.youtube.com/watch?v=fnwhyXFJbh0" target="_blank" rel="noopener noreferrer">interesting journey</a>. i'm currently working on <a href="https://out.so" target="_blank" rel="noopener noreferrer">Out</a>.</h2>
    <h3>have an idea? - ethan@out.so</h3>
    <hr></hr>
    <div style={{ display: 'flex', marginTop: '20px', alignItems: 'center', justifyContent: 'flex-start' }}>
      <a href="https://youtube.com/rice" target="_blank" rel="noopener noreferrer" style={{ marginRight: '10px' }}>
        <img src="/images/yt.png" alt="YouTube Logo" style={{ width: '17px', height: '17px' }} />
      </a>
      <a href="https://github.com/familiar" target="_blank" rel="noopener noreferrer">
        <img src="/images/gh.png" alt="GitHub Logo" style={{ width: '15px', height: '15px' }} />
      </a>
    </div>
  </div>
);

const MyPortfolioContent = () => (
  <div style={{ height: '100%', width: '100%' }}>
    <PhotoAlbum />
  </div>
);

// const Wrapper = styled.div`
//   height: 100vh;
//   display: flex;
//   flex-direction: column;

//   .window {
//     margin: auto;
//     margin-top: 1vh;
//   }

//   .window-title {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//   }
// `;

const App = () => {
  const environmentRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const [isStartMenuVisible, setStartMenuVisible] = useState(false);
  const [zIndexCounter, setZIndexCounter] = useState(1);
  const [activeWindow, setActiveWindow] = useState('aboutMe');
  const [windows, setWindows] = useState({
    aboutMe: { isVisible: true, position: { x: 100, y: 100 }, zIndex: 1 },
    myPortfolio: { isVisible: false, position: { x: 150, y: 150 }, zIndex: 0 }
  });
  const [bootScreenVisible, setBootScreenVisible] = useState(true);
  const [bootMessage, setBootMessage] = useState("Click to boot up your laptop.");
  const audioRef = useRef(new Audio('/sfx/boot.mp3'));
  const backgroundMusicRef = useRef(new Audio('/sfx/lostnfound.mp3'));
  const [contentOpacity, setContentOpacity] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date().toLocaleTimeString()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    audioRef.current.onended = () => {
      setBootScreenVisible(false);
      setContentOpacity(1);

      backgroundMusicRef.current.volume = 0.5;
      backgroundMusicRef.current.loop = true;
      backgroundMusicRef.current.play();
    };
  }, []);

  const toggleWindow = (windowName) => {
    const newZIndex = zIndexCounter + 1;
    const isVisible = !windows[windowName].isVisible;
    setZIndexCounter(newZIndex);
    
    setWindows(prevWindows => ({
      ...prevWindows,
      [windowName]: {
        ...prevWindows[windowName],
        isVisible: isVisible,
        zIndex: isVisible ? newZIndex : prevWindows[windowName].zIndex,
      },
    }));
  
    setActiveWindow(isVisible ? windowName : (activeWindow === windowName ? '' : activeWindow));
  };  

  const startDrag = (windowName, e) => {
    e.preventDefault();
    const newZIndex = zIndexCounter + 1;
    setZIndexCounter(newZIndex);
    setActiveWindow(windowName);
    setWindows(prevWindows => ({
      ...prevWindows,
      [windowName]: {
        ...prevWindows[windowName],
        zIndex: newZIndex,
      },
    }));

    const initialX = e.clientX;
    const initialY = e.clientY;

    const onDrag = (moveEvent) => {
      const dx = moveEvent.clientX - initialX;
      const dy = moveEvent.clientY - initialY;

      setWindows((prevWindows) => ({
        ...prevWindows,
        [windowName]: {
          ...prevWindows[windowName],
          position: { x: windows[windowName].position.x + dx, y: windows[windowName].position.y + dy },
          zIndex: prevWindows[windowName].zIndex,
        },
      }));
    };

    const onDragEnd = () => {
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', onDragEnd);
    };

    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', onDragEnd);
  };

  const handleBootScreenClick = () => {
    setBootMessage("You booted up your laptop.");
    audioRef.current.volume = 0.2;
    audioRef.current.play();
  };  

  return (
    <ThemeProvider>
      <GlobalStyles />
      {bootScreenVisible && (
        <BootScreen onClick={handleBootScreenClick} isVisible={bootScreenVisible}>
          {bootMessage}
        </BootScreen>
      )}
      <ContentContainer opacity={contentOpacity}>
        <Desktop>
          <WindowBorder ref={environmentRef}>
            <WindowedEnvironment>
              <SlidingBackgroundStars />
              <SlidingBackgroundObjects />
              <Taskbar>
              <StyledReact95Button onClick={() => setStartMenuVisible(!isStartMenuVisible)}>
                Start
              </StyledReact95Button>
              {isStartMenuVisible && (
                <List style={{ position: 'absolute', left: '0', bottom: '60px' }}>
                  <List.Item onClick={() => toggleWindow('aboutMe')}>About Me</List.Item>
                  <List.Item onClick={() => toggleWindow('myPortfolio')}>My Portfolio</List.Item>
                </List>
              )}
              <StyledReact95Button
                onClick={() => toggleWindow('aboutMe')}
                isActive={activeWindow === 'aboutMe'}>
                About Me
              </StyledReact95Button>
              <StyledReact95Button
                onClick={() => toggleWindow('myPortfolio')}
                isActive={activeWindow === 'myPortfolio'}>
                My Portfolio
              </StyledReact95Button>
              <Clock>{currentTime}</Clock>
            </Taskbar>
            {Object.keys(windows).map(key => (
              <DraggableModal
                key={key}
                isVisible={windows[key].isVisible}
                onMouseDown={(e) => startDrag(key, e)}
                style={{ 
                  left: windows[key].position.x, 
                  top: windows[key].position.y, 
                  zIndex: windows[key].zIndex,
                  ...(key === 'myPortfolio' ? {
                    width: '600px',
                    height: '650px'
                  } : {
                    width: '400px',
                    height: '300px'
                  })
                }}
                width={key === 'myPortfolio' ? "800" : "400"}
                height={key === 'myPortfolio' ? "600" : "300"}
                title={key.charAt(0).toUpperCase() + key.slice(1)}
                closeModal={() => toggleWindow(key)}
                active={activeWindow === key}
              >
                <div style={{
                  padding: key === 'myPortfolio' ? '0' : '16px',
                  backgroundColor: key === 'myPortfolio' ? 'transparent' : 'white',
                  height: '100%',
                  overflow: 'auto'
                }}>
                  {key === 'aboutMe' && <AboutMeContent />}
                  {key === 'myPortfolio' && <MyPortfolioContent />}
                </div>
              </DraggableModal>
            ))}
          </WindowedEnvironment>
        </WindowBorder>
      </Desktop>
      </ContentContainer>
    </ThemeProvider>
  );
};

export default App;
